import React from 'react';
import { useTranslation } from 'react-i18next';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

import { MEDIA_POOL_SOURCE_MODES } from '../../constants';

import scss from './MediaPoolEmptyDisclaimer.module.scss';

function MediaPoolEmptyDisclaimer({ sourceMode }) {
  const { t } = useTranslation('story');

  const description =
    sourceMode === MEDIA_POOL_SOURCE_MODES.MESSAGE ? t('emptyMediaPoolByMessage') : t('emptyMediaPoolByMedia');

  return (
    <div className={scss.wrapper}>
      <AutoAwesomeOutlinedIcon className={scss.icon} />
      <span className={scss.title}>{t('emptyMediaPoolTitle')}</span>
      <span className={scss.description}>{description}</span>
    </div>
  );
}

export default MediaPoolEmptyDisclaimer;
